import { LIVING_MINIMUM } from '../LegalParameters/Constants';

const CHILDBIRTH = [13000, 10000];
const YEAR = 2019;

export function getLivingMinimum(parents, child6, child15, child26) {
	let result =
		LIVING_MINIMUM[YEAR].FIRST_ADULT +
		child6 * LIVING_MINIMUM[YEAR].CHILDREN[0] +
		child15 * LIVING_MINIMUM[YEAR].CHILDREN[1] +
		child26 * LIVING_MINIMUM[YEAR].CHILDREN[2];

	if (parents === 2) {
		result += LIVING_MINIMUM['2019'].OTHER_ADULT;
	}

	return result;
}

export const isEntitlement = (livingMinimum, income) => income <= livingMinimum * 2.7;

export default function({
	ordinal,
	numberOfExpectedChildren,
	parents,
	child6,
	child15,
	child26,
	income,
}) {
	let entitlement = 'NE';
	let total = 0;

	if (ordinal < 3) {
		const livingMinimum = getLivingMinimum(parents, 1 + child6, child15, child26);
		if (isEntitlement(livingMinimum, income)) {
			entitlement = 'ANO';
			total = ordinal === 1 ? CHILDBIRTH[0] : CHILDBIRTH[1];
			if (numberOfExpectedChildren >= 2) {
				total += 10000;
			}
		}
	}

	return {
		entitlement,
		total,
	};
}
